// eslint-disable-next-line import/prefer-default-export
export const baseUrl = 'https://pokeapi.co/api/v2/pokemon/?limit=50';
